var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('sidebarEl'),_c('div',{staticClass:"page-box"},[_c('headerEl'),_c('div',{staticClass:"page-context"},[_c('homeAnalysisEl')],1)],1),_c('footerEl')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }